<template>
  <!--显示状态信息-->
  <div class="overview-status">
    <div class="status-item flex-layout">
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <span class="circle circle-green"></span>
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.connected }}</div>
      </div>
      <div class="flex-layout col-box" v-if="productName !== 'M4500'">
        <div class="icon-item center">
          <span class="circle circle-blue"></span>
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.connected_powered }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <span class="circle circle-error"></span>
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.error }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <span class="dot dot-disable"></span>
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.disabled }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <span class="dot dot-black"></span>
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.available }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img src="/static/images/port/Block.png" alt="">
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.blocked }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img src="/static/images/port/admin-down.png" alt="">
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.admin_down }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img src="/static/images/port/Warning.gif" alt="">
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.warning }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img src="/static/images/port/authorized.png" alt="">
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.force_authoized }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img src="/static/images/port/unauthorized.png" alt="">
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.force_unauthoized }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img src="/static/images/port/unlock-full.png" alt="">
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.authoized }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img src="/static/images/port/lock-full.png" alt="">
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.unauthoized }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <span class="bold f16">F</span>
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.fanout }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img src="/static/images/port/L.png" alt="">
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.lag }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img src="/static/images/port/trunk.png" alt="">
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.vlan_trunk }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <span class="bold f16">A</span>
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.auto_trunk }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <span class="bold f16">M</span>
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.manual_trunk }}</div>
      </div>
      <div class="flex-layout col-box" v-if="productName !== 'M4500'">
        <div class="icon-item center">
          <img src="/static/images/port/PoE.png" alt="" />
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.poe }}</div>
      </div>
      <div class="flex-layout col-box" v-if="productName !== 'M4500'">
        <div class="icon-item center">
          <img src="/static/images/port/PoE-disabled.png" alt="" />
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.poe_disabled }}</div>
      </div>
      <div class="flex-layout col-box"
        v-for="item in $sakura.locale.conversion.multicast_mode.filter(obj => obj.value > 0 && obj.value != 2)"
        :key="item.value">
        <div class="icon-item center">
          <img src="/static/images/port/Block.png" v-if="item.value == 2" />
          <i class="el-icon-rank" v-if="item.value == 1"></i>
        </div>
        <div class="flex-item tooltip">{{ item.label }}</div>
      </div>
      <div class="flex-layout col-box" v-if="showIcon('s')">
        <div class="icon-item center">
          <img src="/static/images/port/S.png" alt="">
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.fiber_port_1g }}</div>
      </div>
      <div class="flex-layout col-box" v-if="showIcon('sPlus')">
        <div class="icon-item center">
          <img src="/static/images/port/S+.png" alt="">
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.fiber_port_10g }}</div>
      </div>
      <div class="flex-layout col-box" v-if="showIcon('s28')">
        <div class="icon-item center">
          <img src="/static/images/port/S28.png" class="hight-icon" alt="">
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.s28 }}</div>
      </div>
      <div class="flex-layout col-box" v-if="showIcon('qsPlus')">
        <div class="icon-item center">
          <img src="/static/images/port/QSplus.png" class="hight-icon" alt="">
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.qs }}</div>
      </div>
      <div class="flex-layout col-box" v-if="showIcon('q28')">
        <div class="icon-item center">
          <img src="/static/images/port/Q28.png" class="hight-icon" alt="">
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.q28 }}</div>
      </div>
      <div class="flex-layout col-box" v-if="showIcon('s56')">
        <div class="icon-item center">
          <img src="/static/images/port/S56.png" class="hight-icon" alt="">
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.s56 }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img :src="`/static/images/port/crestron.png`" />
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.crestron }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img :src="`/static/images/port/harman.png`" />
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.harman }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img :src="`/static/images/port/audio-technica.png`" />
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.audio_technica }}</div>
      </div>
      <div class="flex-layout col-box" v-if="isDynamic">
        <div class="icon-item center">
          <img src="/static/images/port/dynamic.png" alt="">
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.dynamic_shure_profile }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img :src="`/static/images/port/visionary.png`" />
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.visionary }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img :src="`/static/images/port/NUCLEUS.png`" />
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.nucleus }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img :src="`/static/images/port/kramer.png`" class="more-icon" />
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.kramer }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img :src="`/static/images/port/birddog.png`" class="more-icon" />
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.birddog }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img :src="`/static/images/port/genelec.png`" class="more-icon" />
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.genelec }}</div>
      </div>

      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img :src="`/static/images/port/lightware.png`" class="more-icon" />
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.lightware }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img :src="`/static/images/port/poly.png`" class="more-icon" />
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.poly }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img :src="`/static/images/port/blustream.png`" class="more-icon" />
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.blustream }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img :src="`/static/images/port/sennheiser.png`" />
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.sennheiser }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img :src="`/static/images/port/nice.png`" class="more-icon" />
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.nice }}</div>
      </div>
	    <div class="flex-layout col-box">
        <div class="icon-item center">
          <img :src="`/static/images/port/etc.png`" class="more-icon" />
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.etc }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img :src="`/static/images/port/telos.png`" class="more-icon" />
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.telos }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img :src="`/static/images/port/GandD.png`" class="more-icon" />
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.GandD }}</div>
      </div>
      <div class="flex-layout col-box" v-if="availableModel">
        <div class="icon-item center">
          <img :src="`/static/images/port/urc.png`" class="more-icon" />
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.urc }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img :src="`/static/images/port/more-control.png`" class="more-icon" />
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.control }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img :src="`/static/images/port/more-audio.png`" class="more-icon" />
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.audio }}</div>
      </div>
      <div class="flex-layout col-box">
        <div class="icon-item center">
          <img :src="`/static/images/port/more-video.png`" class="more-icon" />
        </div>
        <div class="flex-item tooltip">{{ $sakura.locale.overview.card.video }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useDeviceStore, useMainStore, useAuthStore } from '@/stores'

// Local state
const isDynamic = ref(false)

const s = ['M4250-9G1F-PoE+', 'M4250-8G2XF-PoE+', 'M4250-10G2F-PoE+', 'M4250-10G2XF-PoE+', 'M4250-10G2XF-PoE++', 'M4250-26G4F-PoE+', 'M4250-26G4XF-PoE+', 'M4250-26G4F-PoE++', 'M4250-40G8F-PoE+', 'M4250-40G8XF-PoE+', 'M4250-40G8XF-PoE++', 'M4300-28G', 'M4300-28G-PoE+', 'M4300-52G', 'M4300-52G-PoE+', 'M4300-8X8F', 'M4300-16X', 'M4300-12X12F', 'M4300-24X', 'M4300-24XF', 'M4300-24X24F', 'M4300-48X', 'M4300-48XF', 'M4300-96X', 'M4350-24G4XF', 'M4350-48G4XF', 'M4350-8X8F', 'M4350-12X12F', 'M4350-24X4V', 'M4350-24F4V', 'M4350-44M4X4V', 'M4250-12M2XF', 'M4500-48XF8C', 'M4350-24F4X', 'M4350-8M2V', 'M4350-24M4X4V']
const sPlus = ['M4250-8G2XF-PoE+', 'M4250-10G2XF-PoE+', 'M4250-10G2XF-PoE++', 'M4250-26G4XF-PoE+', 'M4250-40G8XF-PoE+', 'M4250-40G8XF-PoE++', 'M4300-28G', 'M4300-28G-PoE+', 'M4300-52G', 'M4300-52G-PoE+', 'M4300-8X8F', 'M4300-16X', 'M4300-12X12F', 'M4300-24X', 'M4300-24XF', 'M4300-24X24F', 'M4300-48X', 'M4300-48XF', 'M4300-96X', 'M4350-24G4XF', 'M4350-48G4XF', 'M4350-8X8F', 'M4350-12X12F', 'M4350-24X4V', 'M4350-24F4V', 'M4350-44M4X4V', 'M4250-12M2XF', 'M4500-32C', 'M4500-48XF8C', 'M4350-24X8F8V', 'M4350-32F8V', 'M4350-24F4X', 'M4350-24M4X4V', 'M4350-40F4C', 'M4350-16M4V']
const s28 = ['M4350-24X4V', 'M4350-24F4V', 'M4350-44M4X4V', 'M4500-48XF8C', 'M4350-24X8F8V', 'M4350-36X4V', 'M4350-32F8V', 'M4350-16V4C', 'M4350-24M4X4V', 'M4350-8M2V', 'M4350-16M4V', 'M4350-16C', 'M4500-32C']
const qsPlus = ['M4300-96X', 'M4350-16C', 'M4500-32C', 'M4500-48XF8C']
const q28 = ['M4500-32C', 'M4500-48XF8C', 'M4350-16V4C', 'M4350-40X4C', 'M4350-40F4C', 'M4350-16C']
const s56 = ['M4500-32C', 'M4500-48XF8C', 'M4350-40X4C', 'M4350-16V4C', 'M4350-40F4C']

// Stores
const deviceStore = useDeviceStore()
const unitStore = useMainStore()
const authStore = useAuthStore()

// Computed
const deviceInfo = computed(() => deviceStore.deviceInfo)
const unit = computed(() => unitStore.unit)

const baseInfo = computed(() => {
  const details = deviceInfo.value.details
  if (!details) return {}
  const [one] = details.filter(item => item.unit === unit.value)
  return one || {}
})

const productName = computed(() => {
  return baseInfo.value.model ? baseInfo.value.model.split('-')[0] : ''
})

const availableModel = computed(() => {
  return baseInfo.value.model.toLowerCase().includes('m4250') || baseInfo.value.model.toLowerCase().includes('m4350');
})

// Methods
function showIcon(name) {
  const list = {
    s, sPlus, s28, qsPlus, q28, s56
  }[name]

  return baseInfo.value.model &&
         list &&
         list.map(i => i.toUpperCase()).includes(baseInfo.value.model.toUpperCase())
}

// Lifecycle
onMounted(() => {
  if(productName.value !== 'M4500') {
      authStore.queryShureInfo().then(json => {
      if (json.resp.respCode === 0 && json.activation) {
        isDynamic.value = true
      }
    })
  }
})
</script>


<style lang="scss" scoped>
@use "@/css/mixin.scss" as *;
$base: 12px;

.overview-status {
  padding: 20px 10px 0 10px;

  .status-item {
    flex-wrap: wrap;

    .col-box {
      align-items: center;
      padding: 8px 0;
      width: 25%;

      .icon-item {
        width: 20px;

        img {
          height: $base;
          display: inline-block;
          vertical-align: middle;
        }

        .hight-icon {
          height: $base + 8px;
        }

        .more-icon {
          height: $base + 4px;
          transform: rotate(0deg);
        }

        .circle {
          @include inlineBlock();
          @include wh($base, $base);
          border-radius: 100%;
          border: 2px solid;
        }

        .dot {
          @include inlineBlock();
          @include wh($base, $base);
          border-radius: 100%;
        }

        .circle-blue {
          border-color: #409EFF;
        }

        .circle-green {
          border-color: #00D76F;
        }

        .circle-disable {
          border-color: #E8E9F0;
        }

        .circle-error {
          border-color: #FC3858;
        }

        .dot-black {
          background-color: #0B0B0B;
        }

        .dot-disable {
          background-color: #E8E9F0;
        }
      }

      .tooltip {
        padding-left: 8px;
        color: #aa9a9a;
      }
    }
  }
}
</style>
